import { apiV2 } from './api';

/* ─── In-App-/Browser-Benachrichtigungen (WP4-Ausbau) ─────────────────────
 *
 * GET  /v2/admin/me/notifications      — neueste 20 (unread zuerst)
 * POST /v2/admin/me/notifications/read — ids als gelesen markieren
 *
 * showBrowserNotification(): zeigt eine Web-Notification, wenn die
 * Berechtigung erteilt ist (Einstellungen → Benachrichtigungen).
 */
export interface AdminNotification {
  id: number;
  subject: string;
  message: string;
  meta: Record<string, unknown> | null;
  read_at: string | null;
  created_at: string | null;
}

export const v2Notifications = {
  list: async (): Promise<AdminNotification[]> => {
    const res = await apiV2.get<{ data: AdminNotification[] }>('/admin/me/notifications');
    return res.data.data;
  },

  markRead: async (ids: number[]): Promise<void> => {
    if (ids.length === 0) return;
    await apiV2.post('/admin/me/notifications/read', { ids });
  },
};

/** true, wenn der Browser Web-Notifications unterstützt. */
export function browserNotificationsSupported(): boolean {
  return typeof window !== 'undefined' && 'Notification' in window;
}

/** Aktueller Berechtigungsstatus ('default' | 'granted' | 'denied' | 'unsupported'). */
export function browserNotificationPermission(): NotificationPermission | 'unsupported' {
  return browserNotificationsSupported() ? Notification.permission : 'unsupported';
}

/** Berechtigung anfragen (Einstellungen → "Aktivieren"). */
export async function requestBrowserNotificationPermission(): Promise<NotificationPermission | 'unsupported'> {
  if (!browserNotificationsSupported()) return 'unsupported';
  try {
    return await Notification.requestPermission();
  } catch {
    return Notification.permission;
  }
}

/** Zeigt eine Browser-Notification (no-op ohne Berechtigung). */
export function showBrowserNotification(title: string, body: string): void {
  if (!browserNotificationsSupported() || Notification.permission !== 'granted') return;
  try {
    // Tag verhindert Duplikat-Stapel bei schnellen Requests.
    new Notification(title, { body, icon: '/assets/senihelp24-logo-color.png' });
  } catch { /* z. B. Notification-Konstruktor in Worker-Kontexten */ }
}
